// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RowMenu_panel__Lug0A{width:250px;box-sizing:border-box}`, "",{"version":3,"sources":["webpack://./src/apps/admin/pages/DomainsPage/RowMenu.module.scss"],"names":[],"mappings":"AAEA,sBACE,WAAA,CACA,qBAAA","sourcesContent":["// README \"Row menu\" — width:250px is a resolved width, not min-width, so\n// the pause footnote wraps at menu width instead of stretching the box.\n.panel {\n  width: 250px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `RowMenu_panel__Lug0A`
};
export default ___CSS_LOADER_EXPORT___;
